import React from "react";
import "./Hero.css";
import headerImage from "../assets/header.jpeg";

// ✅ Yeni öğrenci görselleri (assets klasöründen)
import child1 from "../assets/child_crop_1.png";
import child2 from "../assets/child_crop_2.png";
import child3 from "../assets/child_crop_3.png";
import child4 from "../assets/child_crop_4.png";

const Hero = () => {
  return (
    <section
      className="hero-section"
      style={{ backgroundImage: `url(${headerImage})` }}
    >
      <div className="overlay">
        <div className="hero-content">
          <h1>United Nations Simulations</h1>
          <p>
            A leading network of educational simulations that inspire students to engage with global challenges through diplomacy, collaboration, and critical thinking.
            Each conference fosters awareness, dialogue, and innovation — empowering a new generation of thoughtful, solution-oriented leaders.
          </p>
          <a href="mailto:info@ottomun.org" className="cta-btn">
            Ask for information
          </a>

          <div className="students">
            <div className="avatars">
              <img src={child1} alt="Student 1" />
              <img src={child2} alt="Student 2" />
              <img src={child3} alt="Student 3" />
              <img src={child4} alt="Student 4" />
            </div>
            <span>20,000+ Satisfied students</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
